<template>
  <div class="data-comparison-container" id="data-comparison-container">
    <SecondaryCard>
      <div class="content-container">
        <div class="title">
          {{ title }}
        </div>
        <div class="content">
          <DataComparisonContent :data="primaryData" :label="primaryLabel"/>
          <svg
            class="svg"
            width="1"
            height="53"
            viewBox="0 0 1 53"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line x1="0.5" y1="2.18557e-08" x2="0.499998" y2="53" stroke="#C1CCD4"/>
          </svg>
          <DataComparisonContent :data="secondaryData" :label="secondaryLabel"/>
        </div>
      </div>
    </SecondaryCard>
  </div>
</template>

<script>
import { SecondaryCard } from '@mikmak/components';
import DataComparisonContent from './DataComparisonContent.vue';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    primaryData: {
      type: String,
      required: true,
    },
    primaryLabel: {
      type: String,
      required: true,
    },
    secondaryData: {
      type: String,
      required: true,
    },
    secondaryLabel: {
      type: String,
      required: true,
    },
  },
  components: {
    SecondaryCard,
    DataComparisonContent,
  },
};
</script>

<style>
#data-comparison-container .main-card-wrapper {
  padding: 10px;
  box-shadow: none;
  border: 1px solid #C1CCD4;
}
</style>

<style scoped>
.data-comparison-container {
  width: 390px;
  height: 97px;
}

.content-container {
  display: block;
}

.title {
  width: 370px;
  font-size: 16px;
  font-family: Lato;
  font-weight: 700;
  font-style: normal;
  color: #223448;
}

.content {
  height: 83px;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
}

.svg {
  padding-bottom: 3px
}
</style>

